import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  securityApi,
  SecurityEventsParams,
  SecurityEventsResponse,
  BlockedIp,
  CreateBlockedIpData,
} from '@/lib/api';

export const securityKeys = {
  all: ['security'] as const,
  events: (params?: SecurityEventsParams) => [...securityKeys.all, 'events', params] as const,
  blockedIps: () => [...securityKeys.all, 'blocked-ips'] as const,
};

export function useSecurityEvents(params?: SecurityEventsParams) {
  return useQuery<SecurityEventsResponse>({
    queryKey: securityKeys.events(params),
    queryFn: async () => {
      const response = await securityApi.getEvents(params);
      return response.data;
    },
  });
}

export function useBlockedIps() {
  return useQuery<BlockedIp[]>({
    queryKey: securityKeys.blockedIps(),
    queryFn: async () => {
      const response = await securityApi.getBlockedIps();
      return response.data;
    },
  });
}

export function useBlockIp() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateBlockedIpData) => {
      const response = await securityApi.blockIp(data);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: securityKeys.blockedIps() });
    },
  });
}

export function useUnblockIp() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const response = await securityApi.unblockIp(id);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: securityKeys.blockedIps() });
    },
  });
}
